var container = {
  "@media (min-width: 375px)": {
    "paddingLeft": "12px",
    "paddingRight": "12px",
    "maxWidth": "576px"
  },
  "@media (min-width: 768px)": {
    "paddingLeft": "18px",
    "paddingRight": "18px",
    "maxWidth": "720px"
  },
  "@media (min-width: 1024px)": {
    "paddingLeft": "20px",
    "paddingRight": "20px",
    "maxWidth": "940px"
  },
  "@media (min-width: 1280px)": {
    "paddingLeft": "20px",
    "paddingRight": "20px",
    "maxWidth": "1240px"
  },
  "marginLeft": "auto",
  "marginRight": "auto",
  "paddingLeft": "10px",
  "paddingRight": "10px"
};

export { container };
